export default __webpack_public_path__ + "static/media/paper-colored.ce712c64.svg";